export default {
  categoryInfo: {
    mainTitle: 'Araç Kasko Sigortası',
    description: {
      title: 'Kasko Bedeli Nedir?',
      content: [
        'Kasko bedeli araç marka, model ve model yılına göre Türkiye Sigorta Birliği tarafından belirlenen değeri ifade eder. Kasko değer listesinde yer alan kasko bedelleri dönemsel olarak güncellenmektedir.',
        'Kasko araç değer listesinde yer alan araçlar 15 yaşından küçük olan araba türlerini içermektedir. Kasko ve zorunlu trafik sigortası fiyatlarını hesaplanırken bu bedeller dikkate alınır.'
      ]
    },
    subContent: {
      title: 'Araç Kasko Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Kasko poliçesi bir defa lazım olur, onun için <span style="color:red">doğru</span> poliçeyi yaptırmanız son derece önemlidir.',
          subList: null
        },
        {
          paragraph:
            'Kasko poliçesi; çarpma, çarpışma, devrilme, yanma, hırsızlık gibi temel hasarlarını karşılayan sigorta çeşididir. Ek teminatlar arasında doğal afetler, toplumsal hareketler ve terör olayları sonucunda meydana gelen hasar durumları da karşılanabilir. Aracın aldığı zararı karşılamakla beraber aynı zamanda araç içinde bulunan özel eşya ve aksesuarları da <span style="color:red">kasko teminatı</span> kapsamına ek teminat ile dâhil edilebilir.',
          subList: null
        },
        {
          paragraph:
            'Herhangi bir kaza anında araçta bulunan üçüncü şahıslarda meydana gelen bedeni hasarlar da teminat limitleri dâhilinde karşılanır. Trafik sigortası limitlerinin yeterli gelmediği durumlarda artan finansal sorumluluğu alarak, <strong><em><u>İhtiyari Mali Mesuliyet</u></em></strong> teminatı limitlerine kadar poliçe sahibini güvence altına alır.',
          subList: null
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Araç Kasko Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        company: require('@/assets/company-logos/ak-sigorta.jpg'),
        alt: 'Ak Sigorta',
        name: 'Araç Kasko Sigortası',
        assurance: 'Anlaşmalı Servisli',
        desc: '%20 İndirimli Fiyat'
      },
      {
        id: 2,
        company: require('@/assets/company-logos/allianz-sigorta.jpg'),
        alt: 'Allianz Sigorta',
        name: 'Araç Kasko Sigortası',
        assurance: 'Anlaşmasız Servisli',
        desc: '%25 İndirimli Fiyat'
      },
      {
        id: 3,
        company: require('@/assets/company-logos/axa-sigorta.png'),
        alt: 'Axa Sigorta',
        name: 'Araç Kasko Sigortası',
        assurance: 'Anlaşmalı Servisli',
        desc: '%20 İndirimli Fiyat'
      },
      {
        id: 4,
        company: require('@/assets/company-logos/generali-sigorta.png'),
        alt: 'Generali Sigorta',
        name: 'Araç Kasko Sigortası',
        assurance: 'Anlaşmasız Servisli',
        desc: '%25 İndirimli Fiyat'
      },
      {
        id: 5,
        company: require('@/assets/company-logos/mapfre-sigorta.png'),
        alt: 'Mapfre Sigorta',
        name: 'Araç Kasko Sigortası',
        assurance: 'Anlaşmalı Servisli',
        desc: '%20 İndirimli Fiyat'
      },
      {
        id: 6,
        company: require('@/assets/company-logos/turkiye-sigorta.jpg'),
        alt: 'Türkiye Sigorta',
        name: 'Araç Kasko Sigortası',
        assurance: 'Anlaşmasız Servisli',
        desc: '%25 İndirimli Fiyat'
      },
      {
        id: 7,
        company: require('@/assets/company-logos/bereket-sigorta.jpg'),
        alt: 'Bereket Sigorta',
        name: 'Araç Kasko Sigortası',
        assurance: 'Anlaşmalı Servisli',
        desc: '%20 İndirimli Fiyat'
      },
      {
        id: 8,
        company: require('@/assets/company-logos/ankara-sigorta.jpg'),
        alt: 'Ankara Sigorta',
        name: 'Araç Kasko Sigortası',
        assurance: 'Anlaşmasız Servisli',
        desc: '%25 İndirimli Fiyat'
      }
    ]
  },
  faqTitle: 'Sıkça Sorulan Sorular',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: [
    {
      title: 'Araç Kasko Sigortası Zorunlu Mu?',
      content: [
        {
          paragraph:
            'Araç kasko sigortası zorunlu yapılan bir poliçe değildir. Kasko sigortası araç sahibinin isteğine göre yapılan ve sigortalı aracı güvence altına alan sigorta ürünüdür.',
          subList: null
        }
      ]
    },
    {
      title: 'Araç Kasko Sigortası Ne İşe Yarar?',
      content: [
        {
          paragraph:
            'Kasko sigortasının amacı sigorta ettirene ait aracın uğrayacağı zararların karşılanmasını sağlamaktır. ',
          subList: null
        },
        {
          paragraph:
            'Kasko sigortası arabanızı çarpışma dışında öngörülemeyen herhangi bir olaydan korur. Ayrıca bir kaza sırasında meydana gelen kayıpları da kapsar.',
          subList: null
        },
        {
          paragraph:
            'Kapsamlı sigortası araç sahiplerine en büyük rahatlığı sunar.',
          subList: null
        }
      ]
    },
    {
      title: 'Araç Kasko Sigortası Neleri Kapsar?',
      content: [
        {
          paragraph:
            'Aracınıza özel yaptırmış olduğunuz kasko sigortası çarpma, çarpışma, devrilme, yanma, hırsızlık, manevi tazminat teminatlarını sağlayan kasko sigortasıdır. ',
          subList: null
        },
        {
          paragraph: 'Her araç sahibinin kasko poliçesi yaptırması önemlidir. ',
          subList: null
        },
        {
          paragraph:
            'Kasko, aracınızı güvence altına almanızı sağlayan sigorta poliçesidir. Kasko sigortasının neleri kapsayacağını siz belirleyebilirsiniz. Ana teminatların dışında sunulan ek teminat gruplarını inceleyerek, poliçe kapsamını genişletebilirsiniz. Daha uygun kasko ücretleri için ek teminatlardan çıkarma da yapabilirsiniz. Fakat bu noktada araç sürücülerinin dikkat etmeleri gereken en önemli unsur, prim azalmasına giderken gerekli teminatı poliçelerine ekleyip eklemedikleri olmalıdır. Özellik trafikte sık bulunan bir araç sahibiyseniz teminatlarını inceleyerek en doğru kapsamı seçmeye özen göstermelisiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Kasko Sigortası Teminat Dışı Haller Nelerdir?',
      content: [
        {
          paragraph: null,
          subList: [
            'Savaş,',
            'İstila,',
            'Düşman hareketleri,',
            'Darbe,',
            'İç savaş,',
            'İhtilal,',
            'İsyan ve ayaklanma '
          ]
        },
        {
          paragraph:
            'Gibi durumlarda araçta meydana gelebilecek hasarlar kasko sigortası poliçe kapsamı dışındadır. ',
          subList: null
        },
        {
          paragraph:
            'Ayrıca belirtilen bu durumlarda kolluk kuvvetlerinin müdahaleleri nedeni ile oluşabilecek hasarlar da teminat kapsamı dışında kalan durumlardandır.',
          subList: null
        },
        {
          paragraph:
            'Tüm bunların dışında poliçe kapsamında belirtilmeyen durumlar da kasko kapsamı dışında tutulur.',
          subList: null
        }
      ]
    },
    {
      title: 'Araba Kasko Sigortası Yaptırmak Neden Önemlidir?',
      content: [
        {
          paragraph:
            'Zorunlu trafik sigortası ve kasko sigortası bilinen en yaygın iki araç sigortasıdır. Trafik sigortası motorlu kara taşıtları için yapılması zorunlu bir sigortadır. Ancak konu kasko sigortası olduğunda ülkemizde kasko poliçesi yapılma oranı %35 seviyelerindedir ve bu oran oldukça düşüktür. ',
          subList: null
        },
        {
          paragraph:
            'Oysaki bu iki sigorta türü bir birinden çok farklıdır. Trafik sigortanız olsa dahi kasko poliçenizi yaptırmak çok önemlidir. Zorunlu trafik sigortası ile kasko arasındaki farkları bilmek kaskonun önemini daha iyi anlamamıza yardımcı olacaktır. Trafik sigortası karşı araca vereceğiniz zararlara karşı güvence sağlarken, araç kasko sigortası kendi aracınızı güvence altına almaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Kasko Yaptırmamak Nelere Yol Açar?',
      content: [
        {
          paragraph:
            'Kasko yaptırmamak, araç sahiplerini olası bir hasar durumunda yüksek tutarlardaki maddi yükün altına sokacaktır. ',
          subList: null
        },
        {
          paragraph:
            'Araç kaza yaptığında veya her hangi bir sebepten yandığında ya da ufak hasarlar yaşandığında; kasko sigortası hem aracınızı hem de cebinizi korur.',
          subList: null
        },
        {
          paragraph:
            'Kasko bir defa lazım olur, en iyi kasko poliçesini hemen <strong><em><u>alokasko.com</u></em></strong> uzmanlarından alın!',
          subList: null
        }
      ]
    },
    {
      title: 'Kasko Yaş Sınırı Nedir?',
      content: [
        {
          paragraph:
            'Kasko yaş sınırı araç sürücüleri tarafından en çok merak edilen konuların başında gelmektedir. Kasko değer listesi kapsamında 15 yaş üstü araçlar yer almasa da 10-15 yaş arasında olan aracınız için belli başlı sigorta poliçesi sunan şirketler vardır. Bu her araca her şirketten fiyat verilebildiği anlamana gelmemektedir. Aracınız 15 yaş ve üstüyse fiyat teklif formumuzu doldurarak, kasko fiyatı alabileceğiniz şirketleri görebilirsiniz. ',
          subList: null
        }
      ]
    },
    {
      title: 'Kasko Sigortası Her Yıl Yenilenir Mi?',
      content: [
        {
          paragraph:
            'Kasko sigortası isteğe bağlı yapılan sigorta türü olduğundan dolayı yenileme yapılması da isteğe bağlıdır. Poliçe yenileme dönemlerinizi takip ederek hasarsızlık indirimden faydalanabilir ve kasko fiyatlarınızda avantaj elde edebilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Poliçe süresi boyunca hasar almamak ya da küçük hasarları poliçeye yansıtmayarak, tazminat istememek hasarsızlık indirimini hak etmenizi sağlamaktadır. Hasarsız geçen poliçe dönemlerinde düzenli yenileme yaparak %60’ a kadar indirim hakkı elde edebilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Araç Kasko Sigortası Çeşitleri Nelerdir?',
      content: [
        {
          paragraph: 'Araç Kasko Çeşitleri 4’e ayrılmaktadır: ',
          subList: ['Dar Kasko', 'Kasko', 'Genişletilmiş Kasko', 'Tam Kasko']
        },
        {
          paragraph:
            '**Farklılık gösteren sadece ürün çeşitleri değildir. Aynı zamanda teminat kapsamları da değişiklik gösterdiği için poliçe primleri de farklıdır. Kasko sigortası satın alırken ürünler arasında yapacağınız değerlendirme de teminatları ve limitleri baz almaya özen gösterin. ',
          subList: null
        }
      ]
    },
    {
      title: 'Mini Kasko Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Mini kasko sigortası, sigortalı araçların uğrayabileceği küçük çaplı hasarları güvence altına almaktadır. Kasko fiyatlarını değerlendirdiğiniz hem fiyatlar hem de teminatlar fazla geliyorsa mini kasko sigortasını tercih edebilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'En uygun mini kasko fiyatını görüntülemek için teklif formunu doldurabilir ve aracınıza özel sunacağımız teminatları inceleyebilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Dar Kasko Nedir?',
      content: [
        {
          paragraph:
            'Dar kasko sigortası adından da anlaşılacağı gibi kapsamı dar olan bir kasko ürünüdür. Kapsamı, genişletilmiş kaskoya göre daha az olan bu ürünün fiyatı da normal kasko poliçelerine göre daha düşüktür.',
          subList: null
        }
      ]
    },
    {
      title: 'Pert Kasko Nedir?',
      content: [
        {
          paragraph:
            'Pert araçlar, ağır hasar kaydı bulunan araçlardır. Değerini kaybeden ve ağır hasar alıp kullanılamaz hale gelen araçlar bu gruba girer.',
          subList: null
        },
        {
          paragraph:
            'Pert Kasko Sigortası, ana teminat grubunda belirtilen riskler doğrultusunda aracınızı tam hasara karşı veya aracın çalınma riskine karşı güvence altına alan sigorta ürünüdür.',
          subList: null
        }
      ]
    },
    {
      title: 'Araç Pert Kasko Hesaplaması Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Pert araçlara rayiç bedel üzerinden hesaplama yapılmaktadır.  Pert araca kasko fiyatı sunan sigorta şirketleri sayılıdır.',
          subList: null
        }
      ]
    },
    {
      title: 'Pert Araç Kasko Ödeme Süresi Ne Kadardır?',
      content: [
        {
          paragraph:
            'Pert araçlarda aracın servise çekilmesinden sonra maksimum 45 gün içinde araç sahibine tazminatın ödenmesi gerekir. Sigorta şirketleri bu süreyi 30 gün içinde tamamlamaktadırlar.',
          subList: null
        }
      ]
    },
    {
      title: 'Muafiyetli Kasko Nedir?',
      content: [
        {
          paragraph:
            'Kaskoda muafiyet; sigortalı araçta gerçekleşen hasarın belirli bir tutarının sigortalı kişi tarafından karşılanmasına verilen isimdir.',
          subList: null
        },
        {
          paragraph:
            'Muafiyetli kasko satın almak isteyen araç sürücülerine poliçe fiyatları normal kasko fiyatından daha uygun gelir. Burada en önemli nokta muafiyetli kasko poliçesi tercih ediyorsanız, hasar durumunda muafiyet oranı kadar hasar ödemesi yapacağınızı bilmenizdir.',
          subList: null
        },
        {
          paragraph:
            'Bu noktada normal kasko poliçesinde tüm hasar ödemesi sigorta şirketine aitken, muafiyetli kasko da belli bir hasar ödeme oranı size ait olur. Sigorta şirketinin risk ödemesi düşük oran olacağı için normal kasko fiyatlarına nazaran daha az primle güvence sağlar.',
          subList: null
        }
      ]
    },
    {
      title: 'Tamamlayıcı Kasko Nedir?',
      content: [
        {
          paragraph:
            'Tamamlayıcı kasko sigortası, trafik sigortasının karşılamadığı durumları güvence altına almaktadır.',
          subList: null
        },
        {
          paragraph:
            'Tamamlayıcı kasko sigortası yaptırarak trafikte başınıza gelebilecek ancak zorunlu trafik sigortasının karşılamadığı çarpışma, çalınma ve üçüncü şahıslara karşı ihtiyari mali mesuliyet gibi riskleri güvence altına alabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Genişletilmiş Kasko İle Tam Kasko Arasındaki Farklar Nelerdir?',
      content: [
        {
          paragraph:
            'Genişletilmiş kasko sigortası ile tam kasko sigortası arasında küçük bir farklılık vardır. İki sigorta poliçesini karşılaştırmak istediğimizde teminat ve fiyat farkı ortaya çıkmaktadır. Genişletilmiş kasko sigortasında ana teminatlardan hariç sunulan ek teminatların hepsi yer almamaktadır. Fakat tam kasko sigortasında ana teminatlar + tüm ek teminatlar yer almaktadır.',
          subList: null
        },
        {
          paragraph:
            'Sigorta şirketlerinin sunmuş olduğu tüm ek teminatları poliçenize eklemek istemezseniz ve daha uygun bir prim talep ederseniz tercihiniz genişletilmiş kasko sigortası olabilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Genişletilmiş Kasko Sigortası Kapsamı Nedir?',
      content: [
        {
          paragraph:
            'Genişletilmiş kasko sigortasının kapsamı isminden de anlaşılacağı üzere bir hayli kapsamlıdır.',
          subList: null
        },
        {
          paragraph:
            'Kasko çeşitleri arasından genişletilmiş kasko poliçesini tercih edenler;',
          subList: [
            'Kara yolunda veya demir yolunda, motorlu ya da motorsuz taşıtlarla yapılacak kazalara karşı güvence alır.',
            'Trafikte araç hareket halindeyken ya da durma konumundayken, araç sahibi dışında ikinci kişilerin ya da herhangi bir cismin çarpması sonucunda meydana gelebilecek hasarları güvence altına almış olur.',
            'Başkasının aracınıza bilerek vereceği zararları da güvence altına alır.',
            'Fiili ehliyete sahip olmayan kişilerin sebep olacağı hasarlarda teminat kapsamına alınır.'
          ]
        },
        {
          paragraph:
            '***Tüm bunların dışında sunulan ek teminatları değerlendirerek, ihtiyaç dâhiline giren teminatlar satın alınabilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Genel Kasko Teminatları Nelerdir?',
      content: [
        {
          paragraph: null,
          subList: [
            'Çarpma ve çarpışma',
            'Devrilme',
            'Yanma',
            'Üçüncü kişilerin verdiği zararlar',
            'Çalınma teminatlarıdır.'
          ]
        }
      ]
    },
    {
      title: 'Genişletilmiş Kasko Sigorta Ek Teminatları Nelerdir?',
      content: [
        {
          paragraph: null,
          subList: [
            'Anahtar ile sigortalı aracın çalınması ',
            'Doğal afetler (deprem, fırtına, sel su)',
            'Enflasyon teminatı',
            'Eskime payı düşmeme teminatı ',
            'Grev lokavt, halk hareketleri sonucu oluşacak zararlar',
            'Hukuksal koruma teminatı ',
            'Kemirgen hayvanların sigortalı araca vereceği zararlar ',
            'Kullanım kaybı teminatı',
            'Sigara vb. maddelerin teması sonucunda meydana gelebilecek zarar',
            'Terör savaş olağanüstü hal gibi durumlarda askeri müdahale sonucu aracınızın zarar görmesi',
            'Yetkili kişiler tarafında aracın çekilme sırasında doğacak hasarlar',
            'Yurt dışı teminatı ek teminatlar arasından poliçe kapsamına alınabilir.'
          ]
        }
      ]
    },
    {
      title: 'Dar Kasko ve Genişletilmiş Kasko Arasındaki Farklar Nelerdir?',
      content: [
        {
          paragraph:
            'Dar kasko sigortasının fiyatları genişletilmiş kasko sigortası fiyatlarına göre daha ekonomiktir. Bunun en önemli sebebi ürünün sunmuş olduğu güvencedir.',
          subList: null
        },
        {
          paragraph:
            'Dar kasko poliçesi yukardaki maddelerin yalnızca bir ya da bir kaçını teminatı altına alır. Fakat genişletilmiş kasko poliçesi tamamını teminat altına alabilmektedir. ',
          subList: null
        },
        {
          paragraph:
            'Bu sebeple dar kasko ürünü çok daha uygun ekonomik olsa da meydana gelebilecek hasarlarda zararların karşılanması yetersiz kalabilir. ',
          subList: null
        },
        {
          paragraph:
            'Fiyat odaklı yaklaşmanız durumunda dar sigorta fiyatları size cazip gelecektir. Tercih yaparken bilmeniz gereken en önemli durum kasko sigortasını hasar anı için satın aldığınız olmalıdır.',
          subList: null
        }
      ]
    },
    {
      title: 'En İyi Kasko Şirketi Hangisi?',
      content: [
        {
          paragraph:
            'En iyi kasko poliçesini yaptırmak istiyorsanız en iyi teminatları aldığınızdan emin olmalısınız. Doğru teminatları seçerek hazırlanan poliçeler kapsamında herhangi bir sorun yaşamazsınız. Karşılaştırma yaparak, aklınıza takılan soruları poliçenizi onaylamadan önce mutlaka sigorta danışmanınıza sormalısınız.',
          subList: null
        },
        {
          paragraph:
            '“<strong><em><u>En iyi kasko sigortası hangisi?</u></em></strong>”  Sorusunun cevabına baktığımızda ise en iyi kasko şirketi algısı sigortalılara göre farklılık gösterecektir. ',
          subList: null
        },
        {
          paragraph:
            'Sizin için en iyi şirketi <strong><em><u>Alokasko.com</u></em></strong> uzmanları seçebilir! Bunun için tek yapmanız gereken fiyat teklifi istemenizdir.',
          subList: null
        }
      ]
    },
    {
      title: 'Kasko Poliçesinde İhtiyari Mali Mesuliyet Teminatı Nedir?',
      content: [
        {
          paragraph:
            'Hepimizin duyduğu ama çoğumuzun bilmediği İMM (İhtiyari Mali Mesuliyet) teminatı kasko poliçesinin bir teminatıdır. Kaza anında üçüncü şahıslara verilen zararları kapsayan trafik sigortasının yetmediği durumda ortaya çıkarak güvence sunan teminattır. ',
          subList: null
        },
        {
          paragraph:
            'Trafik sigortası kapsamında sunulan maddi zarar teminatı 43.000 TL’dir. (2021 verisidir)',
          subList: null
        },
        {
          paragraph:
            'Hasar bu tutarın üzerinde ise kalan kısmı kasko poliçenizin ihtiyari mali mesuliyet teminatı ödeme yapar. İMM teminatınız kasko poliçenizde yer almıyorsa, aşan kısmı siz ödemekle yükümlü olursunuz, bu sebepten dolayı kasko poliçesi yaptırırken ihtiyari mali mesuliyet teminatına yer vermeniz çok önemlidir.',
          subList: null
        }
      ]
    },
    {
      title: 'Sigorta Bedeli (Rayiç Değer) Nedir?',
      content: [
        {
          paragraph:
            'Sigorta Şirketi aracı hasar tarihi itibariyle rayiç̧ değerine kadar teminat altına almaktadır. Rayiç bedelin önemli olasının sebebi hasar durumunda tazminat ödemesi anında devreye girmesidir.',
          subList: null
        },
        {
          paragraph:
            'Araç rayiç bedeli hesaplanırken Türkiye Sigortalar Birliği (TSB) tarafından her ay güncellenen kasko değer listesi dikkate alınır.',
          subList: null
        }
      ]
    },
    {
      title: 'Kasko Rayı̇ç Bedel (Değer) Tespı̇tı̇ Nedir?',
      content: [
        {
          paragraph:
            'Kasko Sigortası Genel Şartlarının B.3–3.2.2 maddesi gereğince sigortalı aracın tam ziya (pert) hasara uğradığının eksper tarafından tespit edildiği veya aracın çalınıp bulunmadığı durumlarda aracın rayiç̧ değeri sigortacı veya hasar tespitini yapan ekser tarafından internet sitelerinden, yetkili / özel satıcılar ve galerilerden alınan en az 3 (üç̧) adet fiyat teklifinin ortalaması alınarak ödenecek rayiç̧ değer tespit edilir. ',
          subList: null
        },
        {
          paragraph:
            'Alınan fiyat tekliflerin 3 (üç̧) adetten az olması durumunda eksper ve sigortalının önereceği ve sigorta şirketinin de mutabık kalacağı yetkili araç̧ satış̧ yerlerinden (bayiler) alınacak fiyatların ortalaması dikkate alınarak rayiç̧ değer belirlenir.',
          subList: null
        }
      ]
    },
    {
      title: 'Grev Lokavt, Kargaşalık, Halk Hareketleri̇ ve Terör Klozu Nedir? ',
      content: [
        {
          paragraph:
            'Kasko Sigortası Genel Şartları A-4.2 maddesi gereğince "Grev, Lokavt, Kargaşalık ile Halk Hareketleri ve bunları önlemek ve etkilerini azaltmak üzere yetkili organlar tarafından yapılan müdahaleler sonucu meydana gelen zararlar" ve A-4.3 maddesi gereğince "3713 sayılı Terörle Mücadele Kanunu`nda belirtilen terör eylemleri ve bu eylemlerden doğan sabotaj ile bunları önlemek ve etkilerini azaltmak amacıyla yetkili organlar tarafından yapılan müdahaleler sonucunda meydana gelen zararlar" Türkiye Cumhuriyeti sınırları içinde teminat kapsamına dâhil edilmiştir. Ayrıca bu teminat kapsamında yapılacak hasar ödemelerinde Muafiyet uygulanmayacaktır.',
          subList: null
        }
      ]
    },
    {
      title: 'Deprem Toprak Kayması, Fırtına, Dolu ve Yanardağ̆ Klozu Nedir?',
      content: [
        {
          paragraph:
            'Kasko Sigortası Genel Sartlarının A.4 - 4.4 maddesinde belirtilen "Deprem, Toprak Kayması, Fırtına Dolu ve Yanardağ̆ Püskürmesi nedeniyle meydana gelen zararlar" Türkiye Cumhuriyeti sınırları içinde teminat kapsamına dâhil edilmiştir. Bu teminat kapsamında yapılacak hasar ödemelerinde Muafiyet uygulanmayacaktır.',
          subList: null
        }
      ]
    },
    {
      title: 'Sel ve Su Baskını Klozu Nedir?',
      content: [
        {
          paragraph:
            'Kasko Sigortası Genel Sartlarının A.4 - 4.5 maddesinde belirtilen "Sel ve Su Baskını ile meydana gelen zararlar" Türkiye Cumhuriyeti sınırları içinde teminat kapsamına dâhil edilmiştir. Bu teminat kapsamında yapılacak hasar ödemelerinde Muafiyet uygulanmayacaktır. ',
          subList: null
        }
      ]
    },
    {
      title: 'Sigara ve Benzeri Madde Zararları Klozu Nedir?',
      content: [
        {
          paragraph:
            'Kasko Sigortası Genel Şartlarının A.4 - 4.6 maddesinde belirtilen, " Araçta sigara ve benzeri maddelerin teması ile meydana gelen yangın dışındaki zararlar" teminat kapsamına dâhil edilmiştir. ',
          subList: null
        }
      ]
    },
    {
      title: 'Çekme - Çekilme Zararları Klozu Nedir?',
      content: [
        {
          paragraph:
            'Kasko Sigortası Genel Şartlarının A.4-4.7 maddesinde belirt ilen "Yetkili olmayan kişilere çektirilen araca gelen zararlar ile kurallara uygun olmadan çekilen veya çektirilen araçlarda meydana gelen zararlar" teminat kapsamına dâhil edilmiştir. ',
          subList: null
        }
      ]
    },
    {
      title:
        'Asıl Anahtar İle Aracın Çalınması Klozu (Hususi Araçlarda) Nedir?',
      content: [
        {
          paragraph: null,
          subList: [
            'Araç̧ anahtarının, sigortalı veya araç̧ sürücüsünü öldürmek, yaralamak, zor ve şiddet kullanmak veya tehdit etmek sureti ile ele geçirilmesi sureti ile aracın çalınması veya çalınmaya teşebbüs edilmesi sonucu meydana gelebilecek ziya ve hasarlar teminat kapsamına dâhil edilmiştir.',
            'Araç̧ anahtarlarının, sigortalı veya araç̧ sürücüsü tarafından ikametgah veya işyeri niteliğindeki kapalı ve kilitli bir mahalde muhafazası sırasında, bu mahallere kırmak, delmek, yıkmak, devirmek, zorlamak, araç̧-gereç̧ kullanarak veya bedeni çeviklik sayesinde tırmanmak veya aşmak sureti ile girilerek aracın çalınması veya çalınmaya teşebbüs edilmesi sonucu meydana gelebilecek ziya ve hasarlar teminat kapsamına dahil edilmiştir.',
            'Aracın kanunen geçerli bir belge karşılığında gözetim, bakım ve onarım amacı ile aracın teslim edildiği otopark, oto yıkama, tamirhane, restoran vb. işletmelerden aracın çalınması veya çalınmaya teşebbüs edilmesi sonucu meydana gelebilecek ziya ve hasarlar sigortalının yasal sorumlular hakkında yasal bir tahkikat başlatması koşuluyla teminat kapsamına dâhil edilmiştir.'
          ]
        }
      ]
    },
    {
      title: 'Anahtar Kaybı Klozu Nedir?',
      content: [
        {
          paragraph:
            'Kara Araçları Kasko Sigortası Genel şartlarının A.4-4.12 maddesine istinaden sigortalı aracın anahtarının kaybolması ve/veya çalınması halinde aracın güvenliğinin sağlanması amacıyla yapılan kilit sisteminin değiştirilmesi, anahtarın kopyalanması veya yeniden kodlanması masrafları, olay basına ve poliçe süresince azami teminat limiti ile teminat altına alınmıştır. ',
          subList: null
        }
      ]
    },
    {
      title: 'Kemirgen ve Diğer Hayvanların Vereceği Zarar Klozu Nedir?',
      content: [
        {
          paragraph:
            '”Kemirgen ve diğer hayvanların, aracın, motor, elektrik ve mekanik aksamına girerek bu kısımlarda sıkışma veya bu kısımlarda kemirme vb.” yollarla vereceği zararlar teminat kapsamına dâhildir. ',
          subList: null
        }
      ]
    },
    {
      title: 'Yanlış̧ Akaryakıt Dolumu Klozu Nedir?',
      content: [
        {
          paragraph:
            'Sigortalı aracın yetkili akaryakıt servis istasyonlarından akaryakıt alımı yaparken, pompacının yakıt ikmali sırasında kasıtlı veya kusurlu olarak yanlış̧ yakıt vermesi sonucu sigortalı aracın maruz kalacağı mekanik zararlar ve masraflar olay basına ve poliçe süresince poliçede yer alan teminat bedeli ile güvence altına alınmıştır. ',
          subList: null
        }
      ]
    },
    {
      title: 'Araçta Bulunan Özel Eşya Klozu Nedir?',
      content: [
        {
          paragraph:
            'Bu poliçe ile sigortalı araç̧ içinde bulunan sigorta sahibine veya aile fertlerine (Baba, Anne ve Çocukları) ait özel eşyaların, hırsızlık veya gasp sonucunda maruz kalacağı zarar ve ziyan azami teminat limitine kadar teminat altına alınmıştır. Çalınma hadisesi eşyaların araç̧ içinde iken gasp suretiyle, araca zarar verilerek veya araçla birlikte çalınması halinde geçerlidir. ',
          subList: null
        }
      ]
    },
    {
      title:
        'Orijinal Olmayan Aksesuarlar, Ses ve Görüntü̈ Cihazları Teminatı Klozu Nedir?',
      content: [
        {
          paragraph:
            'Araçta bulunan fabrika çıkışlı (orijinal) Radyo-Teyp, CD çalar ve diğer cihazlar (Navigasyon, ses ve görüntü̈ cihazları, iletişim cihazları vs.) ve aksesuarları teminata dâhildir. Sonradan takılan ve poliçe üzerinde belirtilmek şartıyla her türlü̈ Radyo-Teyp, CD çalar ve diğer cihazlar (Navigasyon, ses ve görüntü cihazları, iletişim cihazları vs.) ve aksesuarlar verilen bedel kapsamında teminata dâhildir. ',
          subList: null
        }
      ]
    },
    {
      title: 'Kıymet Kazanma (Eskime Payı) Tenzili Klozu Nedir?',
      content: [
        {
          paragraph:
            'Kasko Sigortası Genel Şartlarının B.3-3.2.3 maddesi hükmü aksine sigortalı aracın hasarlanması halinde kısmi hasarlarda yenisi verilen parçalardan kullanma süresi sınırlı olan tekerlek lastikleri, akü ve katalitik konvektörler hariç̧ eskime payı uygulanmayacaktır. ',
          subList: null
        }
      ]
    },
    {
      title: 'LPG Kullanan Araçların Bildirim Klozu Nedir?',
      content: [
        {
          paragraph:
            'Araçta bulunan fabrika çıkışlı (orijinal) LPG tesisatı ve tüpü̈ teminata dâhildir. Sonradan takılan ve poliçe üzerinde belirtilmek şartıyla yeni LPG tesisatı ve tüpü̈ verilen bedel kapsamında teminata dâhildir. ',
          subList: null
        }
      ]
    },
    {
      title: 'Kasko Hasarsızlık İndirim Nedir?',
      content: [
        {
          paragraph:
            'Kasko aracınızı korurken, bütçenizi de korur demiştik! Hem kaza durumlarına karşı hem de kazasız geçen bir yıllık poliçe süresi kapsamında tam olarak güvence sağlar.',
          subList: null
        },
        {
          paragraph:
            'Kazasız bir yıl tamamlıyorsanız, kasko fiyatlarında hasarsızlık indiriminden faydalanma hakkınız bulunur. ',
          subList: null
        },
        {
          paragraph:
            'Yenileme döneminde kasko fiyatlarını değerlendirirken kazanız yoksa:',
          subList: [
            'Birinci yılın sonundaki yenilemede..................%30,',
            'İkinci yılın sonundaki yenilemede....................%40,',
            'Üçüncü yılın sonundaki yenilemede................%50, ',
            'Dördüncü̈ ve sonraki yıllardaki yenilemelerde………%60 indirim hakkı elde edebilirsiniz.'
          ]
        }
      ]
    },
    {
      title: 'Yeni Değer Klozu Nedir?',
      content: [
        {
          paragraph:
            'Sıfır km. aracın, poliçe süresi (maksimum 12 ay ) içinde tam hasara (yanması, çalınması ve pert olması) uğraması durumunda ödenecek tazminat, aracın marka, model, tip ve aksesuar özellikleri aynı olan yenisinin hasar tarihindeki anahtar teslim satış̧ fiyatı üzerinden tazminat ödenir. Bu tutar hiçbir halde aracın alış fatura tarihi ile hasar tarihi arasındaki süreye uygulanacak gün esaslı enflasyon oranını geçemez. İşbu teminat binek otomobil, arazi taşıtı(SUV),ve kamyonetler için geçerli olup, diğer tüm kullanım tarzlarında ve günlük ve/veya uzun süreli kiraya verilen her türlü̈ araçlar bu teminatın kapsamı dışındadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Ferdi Kaza Koltuk Teminatı Nedir? ',
      content: [
        {
          paragraph:
            'Bu sigorta, motorlu kara taşıtlarında seyahat eden ve poliçe de sayıları belirtilmiş̧ bulunan yolcular ile sürücü̈ ve yardımcılarının, araç̧ gerek hareket halinde, gerekse park hal i n de iken, aracın bakımı yapılırken veya araca inilip binil irken meydana gelecek bir kaza sonucunda ölüm veya sürekli sakatlık hali ile tedavi masraflarını, poliçede yazılı limitlere kadar <strong><em><u>Ferdi Kaza Genel Şartları</u></em></strong> çerçevesinde temin eder. ',
          subList: null
        }
      ]
    },
    {
      title: 'İhtiyari Malı̇ Sorumluluk Teminatı Nedir? ',
      content: [
        {
          paragraph:
            'Bu Teminat, TC sınırları içinde geçerli olup, bu poliçe ile sigortalanan aracın kullanılmasından doğan ve karayolları trafik kanuna ve genel hükümlerine göre aracın işletene ait olan hukuki sorumluluğu ve bu poliçe kapsamında olmak şartıyla zorunlu mali sorumluluk sigortası hadlerinin üzerinde kalan kısmını, poliçede yazılı teminat limitleri dâhilinde temin eder. ',
          subList: null
        }
      ]
    },
    {
      title: 'Hukuksal Koruma Teminatı Nedir? ',
      content: [
        {
          paragraph:
            "Sürücü Hukuksal Koruma teminat ile hukuksal çıkarların korunması için yapılması gereken giderler poliçede belirtilen toplam bedelin, azami %15'i avukatlık ücreti , % 20'si mahkeme masrafları, %5'i danışma ücreti, %10 'u t em inat akçesi, %10'u hakem ücreti, %10'u icra masrafları,%15 'i temyiz ve karar düzeltme, %15'i ihtarname çekimi, dilekçe yazı mı vs. masraflar olarak kullanılır.",
          subList: null
        }
      ]
    },
    {
      title: 'Kasko Sigortası Hangi Hasarlarda Devreye Girer?',
      content: [
        {
          paragraph:
            'Kasko sigortası teminatları kapsamında araç sahibine ve araca güvence sağlanmaktadır. Bu doğrultuda ise poliçede verilen teminatlar hasar durumunda devreye girerek ödeme yapılır.',
          subList: null
        },
        {
          paragraph:
            'Genel olarak kasko sigortası hasarları kapsamında karşılanan durumlar:',
          subList: [
            'Çarpma,',
            'Çarpışma,',
            'Yanma, ',
            'Devrilme sonucu meydana gelen hasarlardır.'
          ]
        },
        {
          paragraph:
            'Bu durumların dışında poliçe eklenen ek teminatların kapsamına giren hasarlar karşılanır.',
          subList: null
        }
      ]
    },
    {
      title: 'Araç Kasko Hangi Durumlarda Ödeme Yapmaz?',
      content: [
        {
          paragraph:
            'Kasko sigorta poliçesinin ödeme yapmadığı durumlar vardır bunlar; ',
          subList: [
            'Çarpma veya çarpışma sonucu olmayan aracın bakımsızlığından kaynaklı oluşan hasarlar.',
            'Araç ruhsatında belirtilen ağırlıkta fazla yük taşınması sonucu meydana gelen hasarlardır.',
            'Savaş, darbe, iş savaş, istila, düşman hareketleri, ihtilal, isyan ve ayaklanma sonucu oluşan hasarlar karşılanmaz.',
            'Sigortalının aracına bilinçli vereceği hasarlarda kasko poliçesinden karşılanmamaktadır.',
            'Ayrıca aracı kullanan kişinin ağır kusuru ile alkol, uyuşturucu vb. maddeler kullanıldığını tespit edilerek rapor düzenlenmesi durumunda bunlardan kaynaklı hasarlar teminat dışı kalmaktadır.'
          ]
        },
        {
          paragraph:
            '** Tüm bu durumların dışında ise kasko da bir hasar karşılanmıyorsa, poliçe kapsamında yer almıyordur. Bu sebeple kasko poliçenizi satın alırken teminatları ihtiyaçlara göre belirlemeye özen göstermelisiniz. Aksi durumda poliçeye eklenmeyen hasar oluşursa kasko şirketi karşılamayacaktır. ',
          subList: null
        }
      ]
    },
    {
      title: 'Araç Kasko Hangi Durumlarda Ödeme Yapar?',
      content: [
        {
          paragraph:
            'Araç kasko sigortası poliçe kapsamında yer alan teminatlar doğrultusunda ödeme yapar. Hangi zararların bütçenize ek maliyet oluşturmasını istemiyorsanız teminat seçimine siz karar vererek, en iyi kasko poliçesini satın alabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Kasko Hasarsızlık İndirimi Ne Kadar Geçerli?',
      content: [
        {
          paragraph:
            'Kasko hasarsızlık indirimi poliçe yenileme döneminizde devreye girmektedir. İlk yıl yaptırdığınız kasko sigortası kapsamında bir hasar yaşamazsanız hasarsızlık indiriminden faydalanabilirsiniz. ',
          subList: null
        },
        {
          paragraph:
            'Hasarsızlık indirimi; her hasarsız geçen yenileme döneminde geçerli olmaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Kasko Bozulursa Ne Kadar Artar?',
      content: [
        {
          paragraph:
            'Kasko sigortası 1 yıllık yapılmaktadır. Bu süre sonunda ise poliçeniz bitmeden tekrar kasko yenilemesi yaparak, teminatlarınızdan yararlanabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Kasko bitiş süresinde yeni hazırlanacak kasko fiyatları yaşanan hasar durumlarına göre artış gösterir. Hasarsızlık basamağınız devreye girer ve sigorta şirketine risk oluşturmuş sigortalıların kasko fiyatlarında artış görülür.',
          subList: null
        },
        {
          paragraph:
            'Hasarsızlık basamağına göre kasko fiyatlarında <strong><em><u>%20 ila %60</u></em></strong> arasında artış görülebilmektedir. Kaskosu bozulan her sigortalının prim artışı aynı oranda olmaz. Hasarınız varsa ve kasko yenileme döneminiz geldiyse en doğru fiyata ulaşmak için <strong><em><u>Alokasko.com</u></em></strong> uzmanlarından fiyat teklifi alabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Araç Kasko Meslek İndirimi Nedir?',
      content: [
        {
          paragraph:
            'Kasko sigortası fiyatları hesaplanırken mesleğinize özel indirim alma şansınız bulunmaktadır. Meslek indiriminden faydalanarak kasko ücretlerini en ucuz seviyeye getirebilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'İndirim oranları sigorta şirketlerine göre farklılık göstermektedir.',
          subList: [
            'Anonim Şirketi Çalışanı: %8 ila %20 indirim',
            'Askeri Personel: %15 ila %25 indirim',
            'Devlet Memuru(657-4/A) ve Emekliler: %5 ila %17 indirim',
            'Doktor: %10 ila %15 indirim',
            'Eczacı: %5 ila %15 indirim',
            'Hemşire: %5 ila %15 indirim',
            'Kamu Personeli: %10 ila %25 indirim',
            'Öğretmen- Öğretim Görevlisi: %5 ila %20 indirim',
            'Sağlık Personeli: %5 ila %15 indirim',
            'Yargı Personeli: %5 ila %20 indirim'
          ]
        }
      ]
    },
    {
      title:
        'Aracımın Plakası Belli Değil Ancak Poliçe Düzenletmek İstiyorum Ne Yapmalıyım?',
      content: [
        {
          paragraph:
            'Aracınızı sıfır aldığınızda plakası olmayacaktır. Bunun için aracınızın faturasını alarak motor şase numaraları ile poliçe düzenletebilirsiniz. ',
          subList: null
        },
        {
          paragraph:
            'Aracın plakası çıktıktan sonra plaka zeyili yapmak için sigortacınızla iletişime geçmeniz gerekmektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Kasko Cam Değişimi Teminatı Nedir?',
      content: [
        {
          paragraph:
            'Aracınıza yaptırmış olduğunuz kasko sigortası kapsamında cam teminatı bulunuyorsa gerekli hizmetlerden yararlanabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Geniş kapsamlı kasko teminatını seçmeniz durumunda yetkili servislerde aracınızın camını değiştirebilirsiniz. Cam değişimi hizmetlerinden yararlanmak isteyen sigortalılar anlaşmalı araç servislerinde poliçe kapsamında işlem yaptırabilmektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Kasko Mini Onarım Hizmeti Kapsamında Neler Yer Alır?',
      content: [
        {
          paragraph:
            'Mini Onarım hizmeti kapsamında mini onarım firması tarafından verilecek servis hizmetler şunlardır: ',
          subList: null
        },
        {
          paragraph:
            'a) “Boyasız Kaporta Göçük Düzeltme” ( 5 cm çapa kadar boya hasarsız kaporta göçükleri) ',
          subList: null
        },
        {
          paragraph:
            "b) ”Boya Hasarlı Kaporta Düzeltme” (10 cm'ye kadar boya hasarlı ı kaporta göçük ve ezikleri) ",
          subList: null
        },
        {
          paragraph:
            'c) “Boya Tamiri, Mini Yama ( 20 cm çapa kadar plastik tampon sıyrıkları, 30 cm ye kadar kaporta panel çizikleri ve sıyrıkları.)',
          subList: null
        },
        {
          paragraph:
            'd) “İç̧ Döşeme Tamiri”(Deri, halı, kumaş̧, plastik üzerindeki 1 cm çapa kadar sigara yanığı, 5 cm çapa kadar yırtık, çizikler, 3 cm çapa kadar plastik parça kopukları)',
          subList: null
        },
        {
          paragraph:
            'e) “Ön Cam Tamiri” (Mandagözü, yıldız, kombine tip gibi 5 cm caba kadar cam kırıkları.) ',
          subList: null
        },
        {
          paragraph:
            'f) “Leke Çıkarma” (İç̧ döşeme kumaş̧ ve halılar üzerindeki 5 cm çapa kadar altmış̧ iki farklı lekenin döşeme ve halı zeminlerden yüksek başarı ile çıkartılması.) ',
          subList: null
        },
        {
          paragraph:
            'g) “Plastik Tampon Tamiri “(Ön ve arka tamponlardaki teknik ol arak onarılabilir her türlü̈ göçük, yırtık, kopuk ve eksik parça gibi plastik hasarları.) ',
          subList: null
        },
        {
          paragraph:
            'Bu hizmet, Özel Otomobiller, SUV 4X4 araçlar, 2,5 ton brüt katar ağırlığına kadar Kamyonet, Minibüs, Mini Van tipindeki hafif ticari araçları kapsamaktadır.',
          subList: null
        },
        {
          paragraph:
            '**Verilen hizmetlerin kapsamı sigorta şirketlerine göre farklılık gösterebilir. En doğru kapsamı değerlendirmek için kasko teklifi alabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Kasko Manevi Tazminat Talepleri Nedir?',
      content: [
        {
          paragraph:
            'Motorlu aracın işletilmesi sırasında üçüncü şahıslara verilen zararlar, kanunen yaptırılması zorunlu olan trafik sigortasından karşılanmaktadır. Fakat zarar, trafik sigortası limitlerini aşarsa devreye kasko sigortası kapsamında yer alan İMM (İhtiyari Mali Mesuliyet) teminatı girer.',
          subList: null
        },
        {
          paragraph:
            'Manevi tazminat davaları ise kusuru kapsamında kazaya sebep olan ruhsat sahibine ya da aracı işleten kişiye açılır. Kusurlu aracın kasko sigortasında yer alan ihtiyari mali mesuliyet klozu altında manevi tazminata ilişkin bir teminat da eklenmişse söz konusu dava kusurlu olan aracın kasko şirketine de açılabilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Araç Kasko Değer Kaybını Karşılar Mı?',
      content: [
        {
          paragraph:
            'Meydana gelen kazalarda hasara uğrayan araçlardan sadece bir araçta değer kaybı oluşmayabilir. Trafik sigortası kapsamında ise sadece tek bir aracın değer kaybı karşılanır ve bu araçta da kazaya sebebiyet vermeyen yanı sorumluluğu olmayan kişidir.',
          subList: null
        },
        {
          paragraph:
            'Kazaya sebep olan kişinin değer kaybı ise kasko sigortasından karşılanabilir. Bu sebeple aracınızı olası risklere karşı güvence altına almanız önemlidir. ',
          subList: null
        },
        {
          paragraph:
            'Kasko değer kaybı karşılaması her şirket için geçerli olmamaktadır. Poliçenizi yaptırırken sigorta uzmanınızdan geniş kapsamlı bilgi almanız bu noktada büyük önem taşır.',
          subList: null
        }
      ]
    },
    {
      title: 'Araç Kasko Anlaşmalı Servisler Nedir?',
      content: [
        {
          paragraph:
            'Kasko poliçenizi yaptırırken poliçeyi hangi durumlar doğrultusunda aldığınız önemlidir.',
          subList: null
        },
        {
          paragraph:
            'Kasko anlaşmalı servislerinde yapılan işlemler, kasko teminatlarından karşılanır ve sigorta şirketi yapılan işlemleri öder. Anlaşmalı servislerde yaptırılan işlemler ise en hızlı şekilde çözüme ulaştırılır.',
          subList: null
        },
        {
          paragraph:
            'Atanan eksper ile anlaşmalı servis tüm sürecinizi takip eder.',
          subList: null
        }
      ]
    },
    {
      title: 'Aracı Başkası Kullanırsa Kasko Sigortasını Hasarı Karşılar Mı?',
      content: [
        {
          paragraph:
            'Kasko sigortası yaptırırken tek sürücü veya çift sürücü indiriminden yararlanmamışsanız, sizin dışınızda aracı kullanan kişinin, araçta oluşturacağı zararlar karşılanır. ',
          subList: null
        },
        {
          paragraph:
            'Kazanın karşılanabilmesi için bu sürücünün trafik kurallarına uygun sürmüş olması ve alkol – uyuşturucu gibi maddeler kullanmamış olması gerekmektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Tek Taraflı Kazalarda Kasko Sigortası Hasarı Karşılar Mı?',
      content: [
        {
          paragraph:
            'Tek taraflı kaza yapmanız durumunda özellikle dikkat etmeniz gereken detaylar aşağıda yer almaktadır.',
          subList: [
            'Olay yeri fotoğrafları net bit şekilde çekilmesi.',
            'Olay yerinden kolluk kuvvetleri aranması ve bu arama saatinin kayıt altına alınması.',
            'Kasko poliçenizden çekici talep edilmelidir.',
            'Tek taraflı kazalarda yaralanma yok ise kolluk kuvvetleri gelmeyecektir. Bu sebepten dolayı olayı anlatacak beyan yazılması yeterli olabilir. Gerekli adımları eksiksiz uygulamanız sonucunda kasko sigortası hasar tazminat talebinizi olumlu karşılayacaktır.'
          ]
        }
      ]
    },
    {
      title: 'Ağır Hasarlı Araca Kasko Yapılır Mı?',
      content: [
        {
          paragraph:
            'Ağır hasar kayıtlı araçlara kasko yapılmaktadır. Fakat her sigorta şirketinden ağır hasarlı araç kasko fiyatı alamazsınız. Bu poliçeyi size sunacak sigorta şirketleri sayılıdır.',
          subList: null
        },
        {
          paragraph:
            'Ağır hasarlı aracınız varsa ve sigorta kapsamına almak istiyorsanız Alokasko.com uzmanlarından destek alabilirsiniz. Bunun için teklif al formunu doldurmanız yeterlidir.',
          subList: null
        }
      ]
    },
    {
      title: 'Ağır Hasarlı Araç Kasko Sigortası Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Ağır hasar kayıtlı araçlara yapılan sigorta poliçesi “pert kasko” olarak adlandırılmaktadır.',
          subList: null
        },
        {
          paragraph:
            'Pert kasko yaptırmak isteyen araç sürücüleri online teklif formunu doldurabilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Kasko Şanzıman Arızasını Karşılar Mı?',
      content: [
        {
          paragraph:
            'Şanzıman arızasını kaskonun karşılaması poliçe kapsamı ile ilgilidir.',
          subList: null
        }
      ]
    },
    {
      title: 'Kasko Aküyü Karşılar Mı?',
      content: [
        {
          paragraph:
            'Kasko sigortası poliçenizde akü kaza anında hasar almış ise hasarınızı karşılar. Ancak akü arıza yapmış ise teminat kapsamına girmez.',
          subList: null
        }
      ]
    },
    {
      title: 'Kasko Beyanı Nasıl Yazılır?',
      content: [
        {
          paragraph:
            'Meydana gelen hasar durumlarında beyan yazmak son derece önemlidir. Beyan yazılmadığı durumlarda ise sigorta şirketiniz hasar ödemenizi yapmaz.',
          subList: null
        },
        {
          paragraph:
            'Kasko beyan formu doldururken dikkat etmeniz gereken en önemli nokta eksiksiz ve doğru bilgi iletmenizdir.',
          subList: null
        },
        {
          paragraph: 'Kasko beyan örneği kapsamında;',
          subList: [
            'Sigortalının bilgileri,',
            'Poliçe numarası,',
            'Sigortalı araç bilgileri,',
            'Kaza bilgileri,',
            'Kaza oluş şekli doğru ve eksiksiz yazılmalıdır.'
          ]
        }
      ]
    },
    {
      title: 'Yedek Anahtar Olmadan Kasko Yapılır Mı?',
      content: [
        {
          paragraph:
            'Yedek anahtarınız yoksa kasko poliçenizi satın alma aşmasında mutlaka iletmelisiniz. Yedek anahtarı bulunmayan araçların güvenlik ve çalınma riskine karşı sigortacısına bilgi vermesi gerekmektedir. Aksi durumda kasko sigortanızı yaptırırken yedek anahtarınızın bulunmadığını iletmezseniz, aracın anahtar ile çalınması halinde mevcut kasko şirketiniz ödemeye yapmayı reddeder.',
          subList: null
        }
      ]
    },
    {
      title: 'Araç Kasko Muhasebe Kaydı Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Yaptırmış olduğunuz kasko poliçesinin bir örneğini muhasebecinize yollamanız gerekmektedir. İlgili kasko poliçesinin muhasebeleştirme işlemini yetkiliniz kayıt altına alarak, gider gösterir ve verginizden düşer.',
          subList: null
        }
      ]
    },
    {
      title: 'Araç Kasko Sigortası İptali Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Kasko sigortası aracınızı olası risklere karşı güvence altına alarak, bütçenizi korur. Poliçe döneminde aksi bir durum gerçekleşmedikçe kasko iptali önerilmemektedir.',
          subList: null
        },
        {
          paragraph:
            'Kasko sigortası kapsamında yer alan sigortalının vefatı ya da sigortalı aracın satılması durumunda kasko iptali yaptırmak isteyebilirsiniz. ',
          subList: [
            'Vefat durumu söz konusu olduğunda iptal edilen poliçe mirasçılara devredilir. Sigortalı vefat etmişse 1 hafta içerisinde sigortacı ile iletişime geçilmelidir.',
            'Sigortalı aracın satışını yapan araç sahibi ise mevcut poliçesini yeni araca devretmek istiyorsa ilk etapta sigorta şirketi ile iletişime geçmelidir. Yeni aracın bilgilerini sigorta şirketine ya da sigortacınıza ileterek kasko devrini gerçekleştirebilirsiniz.',
            'Tüm bunların dışında iptal işlem yapmak istiyorsanız yine sigortacınız ile iletişime geçmeniz durumunda kalan gün sayısı kapsamında prim iadesini talep edebilirsiniz.'
          ]
        }
      ]
    },
    {
      title: 'En Ucuz Kasko Sigortası Tercih Edilmeli Mi?',
      content: [
        {
          paragraph:
            'Kasko fiyatlarını karşılatırken fiyat odaklı yaklaşmayı tercih edebilir ve en ucuz kasko ücretini veren sigorta şirketini seçebilirsiniz. Araştırmalarınız sonucunda satın almaya karar vereceğiniz şirket tamamen size bağlıdır. ',
          subList: null
        },
        {
          paragraph:
            'Fakat bu noktada özellikle dikkat etmeniz gereken en önemli durum, satın alınan en ucuz kasko poliçesi hasar anında ödemelerinizi ne kadar karşılayacak?',
          subList: null
        }
      ]
    },
    {
      title: 'Kasko Sigortasına Ne Kadar Öderim?',
      content: [
        {
          paragraph:
            'Türkiye standartlarına göre ortalama araç değerinden yola çıkacak olursak ortalama 699 TL’den başlayan fiyatlarla kasko sigortası tekliflerini değerlendirebilirsiniz. Fiyatlar poliçenize ekleyeceğiniz teminatlara, aracınıza ve yenileme durumunuza bağlı değişiklik gösterecektir.',
          subList: null
        },
        {
          paragraph:
            'Size özel sunacağımız kasko fiyatlarını değerlendirmek için hemen teklif formunu doldurun.',
          subList: null
        }
      ]
    },
    {
      title: 'Kasko Fiyatını Nasıl Öğrenebilirim?',
      content: [
        {
          paragraph:
            'Kasko fiyatları sigorta şirketlerine göre değişiklik göstermektedir. ',
          subList: null
        },
        {
          paragraph:
            'Alokasko ekibi sizler için 20’den fazla sigorta şirketinin fiyatlarını karşılaştırarak en doğru poliçeyi sizlere sunar.',
          subList: null
        }
      ]
    },
    {
      title: 'Online Kasko Teklifi Almak Neden Avantajlıdır?',
      content: [
        {
          paragraph:
            'Online kasko veya trafik teklifi almak sizin için 22 farklı sigorta şirketinin fiyatlarını karşılaştırma yaparak, en doğru ve en ucuz poliçeyi size sunacağız.',
          subList: null
        },
        {
          paragraph:
            'Online kasko fiyatı almak hem kolay hem hızlı hem de bütçenizden tasarruf elde etmenizi sağlar.',
          subList: null
        }
      ]
    }
  ]
}
